
define('text!libs/strand/src/strand-datepicker/example.html',[],function () { return '<strand-button id="btn">\n\t<label>Select a Date</label>\n</strand-button>\n<strand-datepicker id="dp" target="#btn" start-enabled end-enabled use-timezone="false" use-range="false"></strand-datepicker>\n';});

